"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorText = void 0;
var theme_ui_1 = require("theme-ui");
var ErrorText = function (_a) {
    var text = _a.text, csx = _a.csx;
    return (theme_ui_1.jsx(theme_ui_1.Text, { role: "alert", as: "p", variant: "text.small", color: "warningRed", sx: csx }, text));
};
exports.ErrorText = ErrorText;
